import React, { Component } from 'react';
import './components.css';
import plane from '../images/plane.jpeg';
import { Link } from "react-router-dom";

class TestComp extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
            <div className="row">
                <div className="col">
                    <h3>Aero Japanese Fighter</h3>
                </div>
                <div className="col" style={{textAlign:'right'}}>
                    <Link to={`/test`}>Search Results</Link>
                </div>
            </div>
            <div className="row" style={{width:900, backgroundColor:'white'}}>
                <div className="col" style={{backgroundColor:'white'}}>
                    <img src={plane} alt="plane.jpeg" className="aircraftphoto"></img>
                    <div><Link to={`/Wikipedia`}>Wikipedia</Link></div>
                </div>
                <div className="col" style={{backgroundColor:'white'}}>
                <table className="aircraftdetails">
                                <tbody>
                                <tr key="year"><td>Year of Manufacture</td><td>1933</td></tr>
                                <tr key="country"><td>Country of Manufacturer</td><td>USA</td></tr>
                                <tr key="operators"><td>Operators during WWII</td><td>USA, UK</td></tr>
                                <tr key="group"><td>Primary group</td><td>Bomber</td></tr>
                                </tbody>
                            </table>
                </div>
            </div>
            </React.Fragment>
          );
    }
}
 
export default TestComp;
